import { render, staticRenderFns } from "./WikiCreacion.vue?vue&type=template&id=7bd41cb4&scoped=true&"
import script from "./WikiCreacion.vue?vue&type=script&lang=js&"
export * from "./WikiCreacion.vue?vue&type=script&lang=js&"
import style0 from "./WikiCreacion.vue?vue&type=style&index=0&id=7bd41cb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd41cb4",
  null
  
)

export default component.exports